import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import WorkflowListShell from '../components/workflow/WorkflowListShell';
import NowName from '../components/shared/NowName';
import WorkflowStatusBadge from '../components/workflow/WorkflowStatusBadge';
import CpdFlagChips from '../components/lnd/CpdFlagChips';
import { CPD_STATUS_META } from '../components/workflow/constants';
import { formatDateShort } from '../utils/dateFormat';

// External CPD declarations — list page (docs/modules/workflow-ld-cpd.md).
// Self-service: every logged-in user sees their own declarations; holders of
// ld:cpd:review see all of them. A declaration files on submission, so there
// is no "Hide completed" here — every row is either filed or returned.
const WorkflowCpd = () => {
  const { hasPermission } = useAuth();
  const canReview = hasPermission('ld:cpd:review');
  return (
    <WorkflowListShell
      title="External CPD"
      subtitle={canReview
        ? 'External CPD declarations.'
        : 'Your External CPD declarations.'}
      newTo="/workflow/cpd/new"
      newLabel="New Declaration"
      canCreate
      apiPath="/api/ld/cpd-requests"
      searchPlaceholder="Search declaration / course / staff…"
      rowTo={(r) => `/workflow/cpd/${r.id}`}
      showHideCompleted={false}
      columns={[
        {
          key: 'requestNo',
          label: 'Declaration',
          sortKey: 'requestNo',
          className: 'whitespace-nowrap',
          render: (r) => (
            <Link
              to={`/workflow/cpd/${r.id}`}
              onClick={(e) => e.stopPropagation()}
              className="text-blue-600 hover:text-blue-800 font-medium"
            >
              {r.requestNo}
            </Link>
          ),
        },
        { key: 'staff', label: 'Staff', sortKey: 'staff', className: 'text-slate-700 whitespace-nowrap', render: (r) => <NowName value={r.staffName} now={r.staffNameNow} /> },
        { key: 'trainingTitle', label: 'Course', sortKey: 'trainingTitle', className: 'text-slate-900 max-w-xs truncate', cellTitle: (r) => r.trainingTitle, render: (r) => r.trainingTitle },
        { key: 'category', label: 'Category', sortKey: 'category', className: 'text-slate-700 whitespace-nowrap', render: (r) => r.categoryTitle || '—' },
        { key: 'certificateDate', label: 'Certificate Date', sortKey: 'certificateDate', className: 'text-slate-700 whitespace-nowrap', render: (r) => formatDateShort(r.certificateDate) },
        { key: 'hours', label: 'Hours', sortKey: 'hours', className: 'text-slate-700 whitespace-nowrap', render: (r) => r.hours },
        { key: 'flags', label: 'Flags', render: (r) => <CpdFlagChips flags={r.flags || []} /> },
        { key: 'status', label: 'Status', sortKey: 'status', render: (r) => <WorkflowStatusBadge status={r.status} meta={CPD_STATUS_META} /> },
        { key: 'createdAt', label: 'Submitted', sortKey: 'createdAt', className: 'text-slate-600 whitespace-nowrap', render: (r) => formatDateShort(r.createdAt) },
      ]}
    />
  );
};

export default WorkflowCpd;
